const OPERATOR_EVENT_TYPES = {
    provideOperator: 'provide:operator',
    provideOperators: 'provide:operators',
    provideActiveOperator: 'provide:activeOperator',
    provideOperatorConfig: 'provide:operatorConfig',
    requestOperator: 'request:operator',
    requestOperatorConfig: 'request:operatorConfig',
};
export const POST_EVENT_TYPES = Object.assign(Object.assign({}, OPERATOR_EVENT_TYPES), { provide: 'provide', provideUser: 'provide:user', provideToken: 'provide:token', provideDeviceToken: 'provide:deviceToken', provideMFAStatus: 'provide:MFAStatus', request: 'request', requestUser: 'request:user', requestToken: 'request:token', acknowledge: 'acknowledge', notify: 'notify', provideBreadcrumbsConfig: 'provide:breadcrumbsConfig' });
